import React, { useState } from "react";

const testimonials = [
  {
    name: "Rahel Kay",
    feedback:
      "My Reiki session with Ankita was incredibly powerful and restorative. Her space is beautiful—calm, intentional, and energetically grounding. I felt a deep sense of clearing and renewal throughout the session, like my energy was gently realigning. By the end, it was as if I was vibrating on a new frequency.\n\nHer presence is sincere, grounded, and intuitive. I left feeling lighter, more aligned, and truly at peace. Ankita has a rare gift, and I’m so grateful for her work.",
  },
  {
    name: "S.B. Singh",
    feedback:
      "Grateful for the Reiki healing I received from Ankita. A small nodule was found in my liver some time ago. After six months of consistent Reiki healing, along with the right diet and regular exercise, it’s now dissolved completely. Her care, support, and positive energy made a real difference in my recovery.",
  },
  {
    name: "Vivian",
    feedback:
      "After just one Reiki session, I feel so much lighter and more balanced! It was my first time, and I didn’t know what to expect, but the energy I felt during the session was amazing. I left feeling calm, refreshed, and more in touch with myself than I have in recent times.",
  },
  {
    name: "Sunita S",
    feedback:
      "Distance Reiki really surprised me. I wasn’t sure how it would work remotely, but I could actually feel waves of warmth and relaxation throughout the session. Afterwards, my anxiety was reduced, and I slept better than I had in weeks. I’m definitely coming back for more!",
  },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const handleSlide = (direction) => {
    setFade(false); // start fade out

    setTimeout(() => {
      setCurrentIndex((prev) =>
        direction === "next"
          ? (prev + 1) % testimonials.length
          : (prev - 1 + testimonials.length) % testimonials.length
      );
      setFade(true); // fade in new testimonial
    }, 300); // match with transition duration
  };

  const { name, feedback } = testimonials[currentIndex];

  return (
    <div id="testimonials" className="relative py-12 px-4 sm:px-6 lg:px-8 flex justify-center items-center overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('./lotus_beautiful.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      />

      {/* Card */}
      <div className="bg-white shadow-md rounded-lg p-6 sm:p-8 w-full max-w-md text-center relative z-10 overflow-hidden">
        <h2 className="text-xl sm:text-2xl font-[20px] mb-4 font-bicyclete text-about-me-orange">
          Testimonials
        </h2>
        <p className="text-sm sm:text-base text-[rgb(78,78,78)] font-karla leading-[27px] mb-6">
          Kind words from our clients
        </p>

        {/* Testimonial Content */}
        <div
          className={`transition-opacity duration-500 ${
            fade ? "opacity-100" : "opacity-0"
          }`}
        >
          <p className="text-sm sm:text-base text-[rgb(78,78,78)] font-karla leading-[27px] mb-4 whitespace-pre-wrap">
            "{feedback}"
          </p>
          <p className="font-bold text-gray-900">{name}</p>
        </div>

        {/* Arrows */}
        <div className="flex justify-between items-center mt-6">
          <button
            className="text-2xl sm:text-3xl font-bold text-gray-600 hover:text-gray-900 p-2"
            aria-label="Previous testimonial"
            onClick={() => handleSlide("prev")}
          >
            &#8592;
          </button>
          <span className="testimonial-count">{currentIndex + 1} / {testimonials.length}</span>
          <button
            className="text-2xl sm:text-3xl font-bold text-gray-600 hover:text-gray-900 p-2"
            aria-label="Next testimonial"
            onClick={() => handleSlide("next")}
          >
            &#8594;
          </button>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;